import classNames from 'classnames'
import { observer } from 'mobx-react'
import { Fragment } from 'react'
import './index.scss'
const PopularShops = observer(({ content }: { content: any }) => {
  return (
    <section className="pop-shops">
      <div className="things-col__subtitle">{content?.title}</div>
      <div className="pop-shops__list">
        {content?.list.map((l: any, i: number) => (
          <Fragment key={i}>
            {l.link.length ? (
              <a
                className={classNames('pop-shops__item')}
                key={i}
                href={l.link}
                target="__blank"
              >
                <img src={l.src} />
              </a>
            ) : (
              <div className={classNames('pop-shops__item no-cursor')} key={i}>
                <img src={l.src} />
              </div>
            )}
          </Fragment>
        ))}
      </div>
    </section>
  )
})

export default PopularShops
